import React from "react";
import { useState,useEffect } from "react";
// react plugin used to create datetimepicker
import ReactDatetime from "react-datetime";
// react plugin used to create DropdownMenu for selecting items
import Select from "react-select";
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  CardTitle,
  Label,
  FormGroup,
  Form,
  Input,
  Row,
  Col,
  UncontrolledTooltip,
} from "reactstrap";
import moment from "moment";
import axios from "axios";
import { INSERT_EMAIL_CAMPAIGN ,CHANNEL_CLIENT_CHNLTYPE} from "../../constants";
import NotificationAlert from "react-notification-alert";
import { useHistory } from "react-router-dom";
import SampleCSV from "./emails.csv"
import apiService from "../../variables/apiService";

var initialValues ={
    campaignname: "",
    templateid: 0,
    senderid:0,
    campaignfile: "",
    subject: "",
    priority1:{
      templateid:"",
      channel:"",
      senderid:""
    },
    priority2:{
      templateid:"",
      channel:"",
      senderid:""
    },
    priority3:{
      templateid:"",
      channel:"",
      senderid:""
    },
    priority4: {
      templateid: "",
      channel: "",
      senderid: "",
    }
  }
var channels =[
  {
    value: "",
    label: "Select Channel",
    isDisabled: true,
  },
  { value: 'SMS', label: "SMS" },
  { value: 'Whatsapp', label: "Whatsapp" },
  { value: 'RCS', label: "RCS" },
  { value: "IVR", label: "IVR" },
];
let templates = [];
let senderids = [];

let smstemplates = [];
let smssenderids = [];

let rcstemplates = [];
let rcssenderids = [];

let whatsapptemplates = [];
let whatsappsenderids = [];

let ivrtemplates = [];
let ivrsenderids = [];
let userObj = localStorage.getItem("user");
let user = JSON.parse(userObj);
const Createcampaigns = () => {
  const history = useHistory();
  const [singleSelect, setsingleSelect] = React.useState(null);
  const [emailCampaign, setEmailCampaign] = useState(initialValues);
  const [validation, setValidation] = useState({ isvalid: false, message: "" });
  const [count, setCount] = React.useState(0);
  const [iscalbck, setiscalbck] = useState(false);
  const [error,setError] = useState({
    error:"",
    iserror:false
  })
  const [isLoading, setIsLoading] = useState(true);

  const notificationAlertRef = React.useRef(null);
  const [channel, setChannel] = useState([]);
  const [channelsms, setChannelsms] = useState([]);
  const [channelwhatsapp, setChannelwhatsapp] = useState([]);
  const [channelrcs, setChannelrcs] = useState([]);
  const [channelivr, setChannelivr] = useState([]);
  const [errorhandle,setErrorHandle]= useState()

  useEffect(()=>{
    fetchChanelsbyClient();
    fetchSmsChanelsbyClient();
    fetchWhatsappChanelsbyClient();
    fetchIvrChanelsbyClient();
    fetchRcsChanelsbyClient();
  },[])

  const fetchChanelsbyClient=async()=>{
    setIsLoading(true)

    const payload={
      channels_type:"email",
      clintId:user?.client
    }
    user?.client!=0&&(await axios.post(CHANNEL_CLIENT_CHNLTYPE,payload).then(res=>{
    
      if(res?.data){
      templates=[]
      
      setChannel(res?.data)
     
      res?.data?.map((item,i)=>{
        item?.template&&templates.push({ value:item?.template, label: item?.template })
        
      })
 
    }
      setIsLoading(false)
     }).catch(e=>{
     
      let options = {};
          options = {
            place: "tr",
            message: "Template Not Found",
            type: "warning",
            autoDismiss: 2,
          };
          notificationAlertRef?.current?.notificationAlert(options);
    }))

  }

    //Fetching Template by Whatsapp Channel

   const fetchWhatsappChanelsbyClient = async () => {
    setIsLoading(true);

    const payload = {
      channels_type: "whatsapp",
      clintId: user?.client,
    };
    user?.client != 0 &&
      (await axios
        .post(CHANNEL_CLIENT_CHNLTYPE, payload)
        .then((res) => {
          whatsapptemplates = [];
          const chnlObj = res?.data[0];

          setChannelwhatsapp(res?.data);
        //  setEmailCampaign({ ...emailCampaign, peid: chnlObj.peid });

          res?.data?.map((item, i) => {
            item?.template &&
              whatsapptemplates.push({ value: item?.template, label: item?.template });
          });

          setIsLoading(false);
        })
        .catch((e) => {
          let options = {};
          options = {
            place: "tr",
            message: e.code,
            type: "warning",
            autoDismiss: 2,
          };
          notificationAlertRef?.current?.notificationAlert(options);
        }));
  };


   //Fetching Template by RCS Channel

   const fetchRcsChanelsbyClient = async () => {
    setIsLoading(true);

    const payload = {
      channels_type: "rcs",
      clintId: user?.client,
    };
    user?.client != 0 &&
      (await axios
        .post(CHANNEL_CLIENT_CHNLTYPE, payload)
        .then((res) => {
          rcstemplates = [];
          const chnlObj = res?.data[0];

          setChannelrcs(res?.data);
        //  setEmailCampaign({ ...emailCampaign, peid: chnlObj.peid });

          res?.data?.map((item, i) => {
            item?.template &&
              rcstemplates.push({ value: item?.template, label: item?.template });
          });

          setIsLoading(false);
        })
        .catch((e) => {
          console.log("Error---",e);
          let options = {};
          options = {
            place: "tr",
            message: e.code,
            type: "warning",
            autoDismiss: 2,
          };
          notificationAlertRef?.current?.notificationAlert(options);
        }));
  };


   //Fetching Template by IVR Channel

   const fetchIvrChanelsbyClient = async () => {
    setIsLoading(true);

    const payload = {
      channels_type: "ivr",
      clintId: user?.client,
    };
    user?.client != 0 &&
      (await axios
        .post(CHANNEL_CLIENT_CHNLTYPE, payload)
        .then((res) => {
          ivrtemplates = [];
          const chnlObj = res?.data[0];

          setChannelivr(res?.data);
         // setEmailCampaign({ ...emailCampaign, peid: chnlObj.peid });

          res?.data?.map((item, i) => {
            item?.template &&
              ivrtemplates.push({ value: item?.template, label: item?.template });
          });

          setIsLoading(false);
        })
        .catch((e) => {
          let options = {};
          options = {
            place: "tr",
            message: e.code,
            type: "warning",
            autoDismiss: 2,
          };
          notificationAlertRef?.current?.notificationAlert(options);
        }));
  };

    //Fetching Template by SMS Channel

    const fetchSmsChanelsbyClient = async () => {
      setIsLoading(true);
  
      const payload = {
        channels_type: "sms",
        clintId: user?.client,
      };
      user?.client != 0 &&
        (await axios
          .post(CHANNEL_CLIENT_CHNLTYPE, payload)
          .then((res) => {
            smstemplates = [];
            const chnlObj = res?.data[0];
  
            setChannelsms(res?.data);
           // setEmailCampaign({ ...emailCampaign, peid: chnlObj.peid });
  
            res?.data?.map((item, i) => {
              item?.template &&
                smstemplates.push({ value: item?.template, label: item?.template });
            });
  
            setIsLoading(false);
          })
          .catch((e) => {
            let options = {};
            options = {
              place: "tr",
              message: e.code,
              type: "warning",
              autoDismiss: 2,
            };
            notificationAlertRef?.current?.notificationAlert(options);
          }));
    };
  let priority =0
  const chooseFile = (e) => {
    let a = e.target.value.split(".");

    if (a[1] == "xlsx" || a[1] == "csv") {
      setValidation({
        isvalid: false,
        message: " ",
      });
      setEmailCampaign({ ...emailCampaign, campaignfile: e.target.files[0] });
    } else {
      setValidation({
        isvalid: true,
        message: "Not Supported " + a[1] + " format",
      });
    }
  };

  const changeSender=(data)=>{
 
    senderids=[]
    const chnl=channel.filter(item=>item.template==data.value)
      
    const senderid = chnl[0]?.senderid?.split(",");
        for(let i=0;i<senderid?.length;i++){
          senderids.push({label:senderid[i],value:senderid[i]})
        }
    
    setEmailCampaign(prev=>({...prev,templateid:data,sender:""}))
  }

  const fetchSenderId=(data,chnl)=>{
    if(chnl=="SMS")
    {
     smssenderids = [];
     const chnls = channelsms?.filter((item) => item.template == data.value);
     const senderid = chnls[0]?.senderid?.split(",");
     for (let i = 0; i < senderid?.length; i++) {
      smssenderids.push({ label: senderid[i], value: senderid[i] });
     }
   }
   else if(chnl=="Whatsapp"){
     whatsappsenderids = [];
     const chnls = channelwhatsapp?.filter((item) => item.template == data.value);
     const senderid = chnls[0]?.senderid?.split(",");
     for (let i = 0; i < senderid?.length; i++) {
       whatsappsenderids.push({ label: senderid[i], value: senderid[i] });
     }
   }
   else if(chnl=="RCS"){
     rcssenderids = [];
     const chnls = channelrcs?.filter((item) => item.template == data.value);
     const senderid = chnls[0]?.senderid?.split(",");
     for (let i = 0; i < senderid?.length; i++) {
       rcssenderids.push({ label: senderid[i], value: senderid[i] });
     }
   }
    else if(chnl=="IVR"){
     ivrsenderids = [];
     const chnls = channelivr?.filter((item) => item.template == data.value);
     const senderid = chnls[0]?.senderid?.split(",");
     for (let i = 0; i < senderid?.length; i++) {
       ivrsenderids.push({ label: senderid[i], value: senderid[i] });
     }
   }
  
  

 }

 const checkvalue = (value, priority) => {
  if (priority == "priority1") {
    if (emailCampaign?.priority2?.channel == value) {
      setError({
        iserror: true,
        errorhandle: "already exist in priority2",
        value,
      });
      setEmailCampaign((preemailCampaign) => ({
        ...preemailCampaign,
        priority1: { ...preemailCampaign.priority1, channel: "",templateid:"",senderid:"" },
      }));
    } else if (emailCampaign?.priority3?.channel == value) {
      setError({
        iserror: true,
        errorhandle: "already exist in priority3",
        value,
      });
      setEmailCampaign((preemailCampaign) => ({
        ...preemailCampaign,
        priority1: { ...preemailCampaign.priority1, channel: "",templateid:"",senderid:"" },
      }));
    }else if (emailCampaign?.priority4?.channel == value) {
      setError({
        iserror: true,
        errorhandle: "already exist in priority4",
        value,
      });
      setEmailCampaign((preemailCampaign) => ({
        ...preemailCampaign,
        priority1: { ...preemailCampaign.priority1, channel: "" ,templateid:"",senderid:""},
      }));
    } else {
      setError({
        iserror: false,
        errorhandle: "",
      });
      setEmailCampaign((preemailCampaign) => ({
        ...preemailCampaign,
        priority1: { ...preemailCampaign.priority1, channel: value ,templateid:"",senderid:""},
      }));
    }
  } else if (priority == "priority2") {
    if (emailCampaign?.priority1?.channel == value) {
      setError({
        iserror: true,
        errorhandle: "already exist in priority1",
        value,
      });
      setEmailCampaign((preemailCampaign) => ({
        ...preemailCampaign,
        priority2: { ...preemailCampaign.priority2, channel: "",templateid:"",senderid:"" },
      }));
    } else if (emailCampaign?.priority3?.channel == value) {
      setError({
        iserror: true,
        errorhandle: "already exist in priority3",
        value,
      });
      setEmailCampaign((preemailCampaign) => ({
        ...preemailCampaign,
        priority2: { ...preemailCampaign.priority2, channel: "" ,templateid:"",senderid:""},
      }));
    } else if (emailCampaign?.priority4?.channel == value) {
      setError({
        iserror: true,
        errorhandle: "already exist in priority4",
        value,
      });
      setEmailCampaign((preemailCampaign) => ({
        ...preemailCampaign,
        priority2: { ...preemailCampaign.priority2, channel: "",templateid:"",senderid:"" },
      }));
    } else {
      setError({
        iserror: false,
        errorhandle: "",
      });
      setEmailCampaign((preemailCampaign) => ({
        ...preemailCampaign,
        priority2: { ...preemailCampaign.priority2, channel: value,templateid:"",senderid:"" },
      }));
    }
  } else if (priority == "priority3") {
    if (emailCampaign?.priority1?.channel == value) {
      setError({
        iserror: true,
        errorhandle: "already exist in priority1",
        value,
      });
      setEmailCampaign((preemailCampaign) => ({
        ...preemailCampaign,
        priority3: { ...preemailCampaign.priority3, channel: "" ,templateid:"",senderid:""},
      }));
    } else if (emailCampaign.priority2.channel == value) {
      setError({
        iserror: true,
        errorhandle: "already exist in priority2",
        value,
      });
      setEmailCampaign((preemailCampaign) => ({
        ...preemailCampaign,
        priority3: { ...preemailCampaign.priority3, channel: "" ,templateid:"",senderid:""},
      }));
    } else if (emailCampaign.priority4.channel == value) {
      setError({
        iserror: true,
        errorhandle: "already exist in priority4",
        value,
      });
      setEmailCampaign((preemailCampaign) => ({
        ...preemailCampaign,
        priority3: { ...preemailCampaign.priority3, channel: "" ,templateid:"",senderid:""},
      }));
    }
     else {
      setError({
        iserror: false,
        errorhandle: "",
      });
      setEmailCampaign((preemailCampaign) => ({
        ...preemailCampaign,
        priority3: { ...preemailCampaign.priority3, channel: value ,templateid:"",senderid:""},
      }));
    }
  } else if (priority == "priority4") {
    if (emailCampaign?.priority1?.channel == value) {
      setError({
        iserror: true,
        errorhandle: "already exist in priority1",
        value,
      });
      setEmailCampaign((preemailCampaign) => ({
        ...preemailCampaign,
        priority4: { ...preemailCampaign.priority4, channel: "" ,templateid:"",senderid:""},
      }));
    } else if (emailCampaign.priority2.channel == value) {
      setError({
        iserror: true,
        errorhandle: "already exist in priority2",
        value,
      });
      setEmailCampaign((preemailCampaign) => ({
        ...preemailCampaign,
        priority4: { ...preemailCampaign.priority3, channel: "" ,templateid:"",senderid:""},
      }));
    }  else if (emailCampaign.priority3.channel == value) {
      setError({
        iserror: true,
        errorhandle: "already exist in priority3",
        value,
      });
      setEmailCampaign((preemailCampaign) => ({
        ...preemailCampaign,
        priority4: { ...preemailCampaign.priority4, channel: "" ,templateid:"",senderid:""},
      }));
    } 
    
    else {
      setError({
        iserror: false,
        errorhandle: "",
      });
      setEmailCampaign((preemailCampaign) => ({
        ...preemailCampaign,
        priority4: { ...preemailCampaign.priority4, channel: value,templateid:"",senderid:"" },
      }));
    }
  }
};

  const isValidForm=()=>{
    const errors = {};
    const onlylettersRegex =/^[a-zA-Z ]+$/;
    if(!emailCampaign?.campaignname){
      errors.campaignname="Campaign Name Required"
    }else if(!(emailCampaign.campaignname.match(onlylettersRegex))){
      errors.campaignname="Please Enter Valid Name"
    }else if(emailCampaign?.campaignname?.length<=3){
      errors.campaignname="Please Enter Valid Name"
    }
    if(!emailCampaign?.campaignfile){
      errors.campaignfile="File Required"
    }
    if(!emailCampaign?.templateid?.value){
      errors.templateid="Templateid Required"
    }
    if(!emailCampaign?.senderid?.value){
      errors.senderid="Senderid Required"
    }
    if(!emailCampaign?.subject){
      errors.subject="Subject Required"
    }
    
  
    return errors;
  }
  const submitEmail = () => {
    const isValid= isValidForm();
    setErrorHandle(isValid)
   
    if(Object.keys(isValid).length==0){
      
    const formData = new FormData();
    formData.append("file", emailCampaign?.campaignfile);
    formData.append("campaignname", emailCampaign?.campaignname);
    formData.append("templateid", emailCampaign?.templateid?.value);
    formData.append("subject", emailCampaign.subject);

    const config = {
      headers: {
        "content-type": "multipart/form-data",
      },
    };
    
   
if(!iscalbck){
     apiService
      .postData(INSERT_EMAIL_CAMPAIGN, formData, config)
      .then((response) => {
        setEmailCampaign(initialValues)
        let options = {};
        options = {
          place: "tr",
          message: "Sent Successfully",
          type: "success",
          autoDismiss: 2
        };
        notificationAlertRef.current.notificationAlert(options);
       
      })
      .catch((err) => console.log("err==>", err));

}else{

}
 
    }
  };
  return (
    <>
      <div className="content">
        <Row>
          <Col md="12">
            <Card>
              <CardBody>
                <NotificationAlert ref={notificationAlertRef} />
                <Form action="#">
                  <Row>
                    <Col md="4" sm="12">
                      <label>Name *</label>
                      <FormGroup>
                        <Input
                          type="text"
                          placeholder="Campaign Name"
                          value={emailCampaign.campaignname}
                          onChange={(e) =>
                            setEmailCampaign({
                              ...emailCampaign,
                              campaignname: e.target.value,
                            })
                          }
                        />
                      </FormGroup>
                      <span style={{color:"red"}}>{errorhandle?.campaignname}</span>
                    </Col>
                    
                    <Col md="4" sm="12">
                      <Label>
                        Bulk Upload (<b>Upload CSV File</b>)
                      </Label>

                      <FormGroup>
                        <Input
                          placeholder="placeholder"
                          accept=".csv"
                          onChange={(e) => chooseFile(e)}
                          type="file"
                          style={{
                            opacity: "1",
                            position: "initial",
                            border: "solid 1px #eee",
                          }}
                        />
                      <a href={SampleCSV} download ="Sample Email File">  <p style={{marginLeft:"40%",color:"#e14eca"}}>*Download sample csv file</p></a>
                      </FormGroup>
                      <span style={{color:"red"}}>{errorhandle?.campaignfile}</span>
                      {validation.isvalid && (
                        <span style={{ color: "red" }}>
                          {validation.message}
                        </span>
                      )}
                    </Col>

                    <Col md="4" sm="12">
          <p className="category">Select Template<suf style={{color:"red"}}>*</suf> </p>
          <Select
            className="react-select info"
            classNamePrefix="react-select"
            name="templateSelect"
            value={emailCampaign.templateid}
            onChange={(value) =>  changeSender(value)}
            options={templates}
            placeholder="Select"
          />
          <span style={{color:"red"}}>{errorhandle?.templateid}</span>
        </Col>
        <Col md="4" sm="12">
          <p className="category">Select Sender</p>
          <Select
            className="react-select info"
            classNamePrefix="react-select"
            name="senderSelect"
            value={emailCampaign?.senderid}
            onChange={(value) => setEmailCampaign(prev=>({...prev,senderid:value}))}
            options={senderids}
            placeholder="Select"
          />
          <span style={{color:"red"}}>{errorhandle?.senderid}</span>
        </Col> 
                    <Col md="4" sm="12">
                      <label>Subject </label>
                      <FormGroup>
                        <Input
                          type="textarea"
                          placeholder="Enter Subject"
                          maxLength={160}
                          value={emailCampaign.subject.substring(0, 160)}
                          onChange={(e) => {
                            setEmailCampaign({
                              ...emailCampaign,
                              subject: e.target.value,
                            });
                            setCount(e.target.value.length);
                          }}
                        />
                        <label style={{ float: "right" }}>{count} / 160</label>
                      </FormGroup>
                      <span style={{color:"red"}}>{errorhandle?.subject}</span>
                    </Col>
                 
                 
                  </Row>
                  {error.iserror && (
                    <h6 style={{ color: "red" }}>{error.errorhandle}</h6>
                  )}
                  <Row><Col md="4" className="mb-2 ">
                      <FormGroup check>
                        <Label check>
                          <Input
                            type="checkbox"
                            checked={iscalbck}
                            value={iscalbck}
                            onClick={(e) => {
                              e.target.checked === true
                              ? setiscalbck(true)
                              : setiscalbck(false);
                            }}
                          />
                          <span className="form-check-sign" />
                          Fall back
                        </Label>
                      </FormGroup>
                    </Col>
                    </Row>
                    {iscalbck && (
                    <>
                      <Row style={{ marginTop: "10px" }}>
                        <Col sm="1" className="mb-2 ">
                          <Label>Priority 1</Label>
                        </Col>
                        <Col sm="3" className="mb-2">
                          <Select
                            className="react-select info"
                            classNamePrefix="react-select"
                            name="channel"
                            // value={.smsSlct}
                            onChange={(value) => {
                              checkvalue(value?.label, "priority1");
                              //setEmailCampaign({...emailCampaign,priority1.channel: value});
                             //  setEmailCampaign((preemailCampaign)=>({...preemailCampaign,priority1:{...preemailCampaign.priority1,channel:value}}))
                            }}
                            options={channels}
                            placeholder="Select Channel"
                          />
                        </Col>
                        <Col sm="3" className="mb-2">
                          <Select
                            className="react-select info"
                            classNamePrefix="react-select"
                            name="template"
                             value={emailCampaign?.priority1?.templateid}
                            onChange={(value) => {
                              setEmailCampaign((preemailCampaign)=>({...preemailCampaign,priority1:{...preemailCampaign.priority1,templateid:value}}))
                            
                               fetchSenderId(value,emailCampaign.priority1.channel)
                            }}
                             options={emailCampaign.priority1.channel=="Whatsapp"?whatsapptemplates:emailCampaign.priority1.channel=="IVR"?ivrtemplates:emailCampaign.priority1.channel=="SMS"?smstemplates:rcstemplates}
                            placeholder="Select Template"
                          />
                        </Col>
                        <Col sm="3" className="mb-2">
                      <Select
                        className="react-select info"
                        classNamePrefix="react-select"
                        name="senderId"
                        value={emailCampaign?.priority1?.senderid}
                        onChange={(value) => {
                          setEmailCampaign((preemailCampaign)=>({...preemailCampaign,priority1:{...preemailCampaign.priority1,senderid:value}}))
                        }}
                        options={emailCampaign.priority1.channel=="Whatsapp"?whatsappsenderids:emailCampaign.priority1.channel=="IVR"?ivrsenderids:emailCampaign.priority1.channel=="SMS"?smssenderids:rcssenderids}
                       
                           
                        placeholder="Select SenderId"
                      />
                    </Col>
                      </Row>
                      <Row style={{ marginTop: "10px" }}>
                        <Col sm="1" className="mb-2 ">
                          <Label>Priority 2</Label>
                        </Col>
                        <Col sm="3" className="mb-2">
                          <Select
                            className="react-select info"
                            classNamePrefix="react-select"
                            name="channel"
                            options={channels}
                            onChange={(value) => {
                              checkvalue(value?.label, "priority2");
                              
                              //setEmailCampaign({...emailCampaign,priority1.channel: value});
                               //  setEmailCampaign((preemailCampaign)=>({...preemailCampaign,priority2:{...preemailCampaign.priority2,channel:value}}))
                            }}
                           
                            placeholder="Select Channel"
                          />
                        </Col>

                        <Col sm="3" className="mb-2">
                          <Select
                            className="react-select info"
                            classNamePrefix="react-select"
                            name="template"
                             value={emailCampaign?.priority2?.templateid}
                            onChange={(value) => {
                              setEmailCampaign((preemailCampaign)=>({...preemailCampaign,priority2:{...preemailCampaign.priority2,templateid:value}}))
                            
                              fetchSenderId(value,emailCampaign.priority2.channel)
                           
                            }}
                            // options={selectType}
                            options={emailCampaign.priority2.channel=="Whatsapp"?whatsapptemplates:emailCampaign.priority2.channel=="IVR"?ivrtemplates:emailCampaign.priority2.channel=="SMS"?smstemplates:rcstemplates}
                          
                            placeholder="Select Template"
                          />
                        </Col>
                        <Col sm="3" className="mb-2">
                      <Select
                        className="react-select info"
                        classNamePrefix="react-select"
                        name="senderId"
                        value={emailCampaign?.priority2?.senderid}
                        onChange={(value) => {
                          setEmailCampaign((preemailCampaign)=>({...preemailCampaign,priority2:{...preemailCampaign.priority2,senderid:value}}))
                        }}
                        options={emailCampaign.priority2.channel=="Whatsapp"?whatsappsenderids:emailCampaign.priority2.channel=="IVR"?ivrsenderids:emailCampaign.priority2.channel=="SMS"?smssenderids:rcssenderids}
                       
                           
                        placeholder="Select SenderId"
                      />
                    </Col>
                      </Row>
                      <Row style={{ marginTop: "10px" }}>
                        <Col sm="1" className="mb-2 ">
                          <Label>Priority 3</Label>
                        </Col>
                        <Col sm="3" className="mb-2">
                          <Select
                            className="react-select info"
                            classNamePrefix="react-select"
                            name="channel"
                            options={channels}
                            onChange={(value) => {
                              checkvalue(value?.label, "priority3");
                              //setEmailCampaign({...emailCampaign,priority1.channel: value});
                             //  setEmailCampaign((preemailCampaign)=>({...preemailCampaign,priority3:{...preemailCampaign.priority3,channel:value}}))
                            }}
                           
                            placeholder="Select Channel"
                          />
                        </Col>

                        <Col sm="3" className="mb-2">
                          <Select
                            className="react-select info"
                            classNamePrefix="react-select"
                            name="template"
                             value={emailCampaign?.priority3?.senderid}
                            onChange={(value) => {
                              setEmailCampaign((preemailCampaign)=>({...preemailCampaign,priority3:{...preemailCampaign.priority3,templateid:value}}))
                            
                              fetchSenderId(value,emailCampaign.priority3.channel)
                            }}
                            options={emailCampaign.priority3.channel=="Whatsapp"?whatsapptemplates:emailCampaign.priority3.channel=="IVR"?ivrtemplates:emailCampaign.priority3.channel=="SMS"?smstemplates:rcstemplates}
                          
                            placeholder="Select Template"
                          />
                        </Col>
                        <Col sm="3" className="mb-2">
                      <Select
                        className="react-select info"
                        classNamePrefix="react-select"
                        name="senderId"
                        value={emailCampaign?.priority3?.senderid}
                        onChange={(value) => {
                          setEmailCampaign((preemailCampaign)=>({...preemailCampaign,priority3:{...preemailCampaign.priority3,senderid:value}}))
                        }}
                        options={emailCampaign.priority3.channel=="Whatsapp"?whatsappsenderids:emailCampaign.priority3.channel=="IVR"?ivrsenderids:emailCampaign.priority3.channel=="SMS"?smssenderids:rcssenderids}
                       
                           
                        placeholder="Select SenderId"
                      />
                    </Col>
                      </Row>
                      <Row style={{ marginTop: "10px" }}>
                        <Col sm="1" className="mb-2 ">
                          <Label>Priority 4</Label>
                        </Col>
                        <Col sm="3" className="mb-2">
                          <Select
                            className="react-select info"
                            classNamePrefix="react-select"
                            name="channel"
                            options={channels}
                            onChange={(value) => {
                              checkvalue(value?.label, "priority4");
                              //setEmailCampaign({...emailCampaign,priority1.channel: value});
                             //  setEmailCampaign((preemailCampaign)=>({...preemailCampaign,priority4:{...preemailCampaign.priority4,channel:value}}))
                            }}
                           
                            placeholder="Select Channel"
                          />
                        </Col>

                        <Col sm="3" className="mb-2">
                          <Select
                            className="react-select info"
                            classNamePrefix="react-select"
                            name="template"
                             value={emailCampaign.priority4.senderid}
                            onChange={(value) => {
                              setEmailCampaign((preemailCampaign)=>({...preemailCampaign,priority4:{...preemailCampaign.priority4,templateid:value}}))
                            
                              fetchSenderId(value,emailCampaign.priority4.channel)
                             }}
                            options={emailCampaign.priority4.channel=="Whatsapp"?whatsapptemplates:emailCampaign.priority4.channel=="IVR"?ivrtemplates:emailCampaign.priority4.channel=="SMS"?smstemplates:rcstemplates}
                          
                            placeholder="Select Template"
                          />
                        </Col>
                        <Col sm="3" className="mb-2">
                      <Select
                        className="react-select info"
                        classNamePrefix="react-select"
                        name="senderId"
                        value={emailCampaign?.priority4?.senderid}
                        onChange={(value) => {
                          setEmailCampaign((preemailCampaign)=>({...preemailCampaign,priority4:{...preemailCampaign.priority4,senderid:value}}))
                        }}
                        options={emailCampaign.priority4.channel=="Whatsapp"?whatsappsenderids:emailCampaign.priority4.channel=="IVR"?ivrsenderids:emailCampaign.priority4.channel=="SMS"?smssenderids:rcssenderids}
                       
                           
                        placeholder="Select SenderId"
                      />
                    </Col>
                      </Row>
                    </>
                  )}
                  <Row>
                    
                  <Col md="4" sm="12">
                      <Button
                        color="primary "
                        className="mt-4 btn btn-icon animation-on-hover"
                        id="tooltipsubmit"
                        type="button"
                      >
                        <i
                          className="tim-icons icon-double-right"
                          onClick={() => submitEmail()}
                        />
                      </Button>
                      <UncontrolledTooltip
                        delay={0}
                        placement="top"
                        target="tooltipsubmit"
                      >
                        Submit
                      </UncontrolledTooltip>
                    </Col>
                  </Row>
                </Form>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default Createcampaigns;
